import { render, staticRenderFns } from "./OnboardList.vue?vue&type=template&id=6c425162&"
import script from "./OnboardList.vue?vue&type=script&lang=js&"
export * from "./OnboardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports